module.exports = __webpack_public_path__ + "3b87a2e2098364dcd11b6a5d97c157a0.pdf";